import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { makeStyles } from "tss-react/mui";
var useStyles = makeStyles()(function(theme) {
    return {
        bar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create([
                "width",
                "margin"
            ], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen
            }),
            backgroundImage: "none",
            "@media print": {
                display: "none"
            }
        },
        toolbar: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingLeft: 16,
            paddingRight: 16,
            height: "100%"
        },
        leftContainer: {
            height: "100%",
            display: "flex",
            alignItems: "center"
        },
        rightsideGuttersSmall: {
            paddingRight: 8
        },
        rightsideGuttersLarge: {
            paddingRight: 16
        },
        stagingStriped: {
            backgroundImage: "repeating-linear-gradient(-45deg, ".concat(theme.palette.primary.main, ", ").concat(theme.palette.primary.main, " 10px, rgba(255, 255, 255, 0.075) 10px, rgba(255, 255, 255, 0.075) 20px)")
        },
        verticalAlignMiddle: {
            verticalAlign: "middle"
        },
        wrapper: {
            position: "relative",
            display: "inline-block"
        },
        buttonPadding: _define_property({}, theme.breakpoints.down("sm"), {
            padding: 5
        })
    };
});
export var Header = function(_param) {
    var left = _param.left, right = _param.right, className = _param.className, props = _object_without_properties(_param, [
        "left",
        "right",
        "className"
    ]);
    var ref = useStyles(), classes = ref.classes, cx = ref.cx;
    var theme = useTheme();
    var smallScreen = useMediaQuery(theme.breakpoints.down("md"));
    return /*#__PURE__*/ _jsx(AppBar, _object_spread_props(_object_spread({
        color: "default",
        className: cx(classes.bar, className),
        position: smallScreen ? "absolute" : "fixed"
    }, props), {
        children: /*#__PURE__*/ _jsxs(Toolbar, {
            disableGutters: true,
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: classes.leftContainer,
                    children: left
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: right
                })
            ]
        })
    }));
};
